import React from "react";
import { DRAFT_TO_DOC_TYPE_WITH_LISTS } from "./../ricos-types/index.js";
const headingsMap = {
  "header-one": "Heading 1",
  "header-two": "Heading 2",
  "header-three": "Heading 3",
  "header-four": "Heading 4",
  "header-five": "Heading 5",
  "header-six": "Heading 6",
  unstyled: "P"
};
const findOsName = () => {
  if (navigator.userAgent.indexOf("Win") !== -1) return "Windows";
  if (navigator.userAgent.indexOf("Mac") !== -1) return "MacOS";
  return null;
};
const headingShortcuts = {
  MacOS: (number) => ` (⌘⌥${number})`,
  Windows: (number) => ` (Ctrl+Alt+${number})`
};
const translateHeading = (option = "P", t, shouldAddShortcut = false) => {
  const number = parseInt(option.slice(-1)) ? option.slice(-1) : void 0;
  const osName = findOsName();
  const shortcut = shouldAddShortcut && osName ? headingShortcuts[osName](number || 0) : void 0;
  return option === "P" ? t("FormattingToolbar_TextStyle_Paragraph", shortcut && { shortcut }) : t("FormattingToolbar_TextStyle_Heading", shortcut ? { number, shortcut } : { number });
};
const getCustomHeadingsLabel = (selectedHeading, t, publicCommands) => {
  const label = translateHeading(
    headingsMap[selectedHeading],
    t
  );
  const inlineStyles = publicCommands.getInlineStylesInSelection() || {};
  const isAsteriskVisible = hasStyleChanges(
    selectedHeading,
    inlineStyles,
    publicCommands.getDocumentStyle()
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, label, /* @__PURE__ */ React.createElement("span", { style: { width: "1ch", marginInline: "-3px" } }, isAsteriskVisible ? "*" : null));
};
const hasStyleChanges = (currentHeading, inlineStyles, documentStyle) => {
  const key = DRAFT_TO_DOC_TYPE_WITH_LISTS[currentHeading];
  const headerStyle = documentStyle?.[key] || {};
  return Object.entries(inlineStyles).some(
    ([key2, value]) => headerStyle[key2] !== value
  );
};
export {
  getCustomHeadingsLabel,
  hasStyleChanges,
  headingsMap,
  translateHeading
};
//# sourceMappingURL=headings-dropdown-utils.js.map
